// extracted by mini-css-extract-plugin
export var calltoAction_btn_wrap = "CallToActionButton-module--calltoAction_btn_wrap--04b5e";
export var calltoAction_trim = "CallToActionButton-module--calltoAction_trim--c14b4";
export var colored = "CallToActionButton-module--colored--5a003";
export var white = "CallToActionButton-module--white--39141";